const configMissingExceptionMessage = (propName: string) =>
  `Failed to provide required configured value '${propName}'.`;
const configParseExceptionMessage = (propName: string) =>
  `Failed to parse configured value '${propName}' to the expected type.`;
const version = process.env.REACT_APP_VERSION_NO;
if (!version) throw configMissingExceptionMessage("REACT_APP_VERSION_NO");

const environmentName = process.env.REACT_APP_ENVNAME;
if (!environmentName) throw configMissingExceptionMessage("REACT_APP_ENVNAME");

const a1cMaximum = process.env.REACT_APP_MAXIMUM_A1C;
if (!a1cMaximum) throw configMissingExceptionMessage("REACT_APP_MAXIMUM_A1C");
const a1cUpperLimit = Number(a1cMaximum);
if (isNaN(a1cUpperLimit)) throw configParseExceptionMessage("REACT_APP_MAXIMUM_A1C");

const convertDotComAccountId = process.env.REACT_APP_CONVERT_DOT_COM_ACCOUNT_ID;
if (!convertDotComAccountId) throw configMissingExceptionMessage("REACT_APP_CONVERT_DOT_COM_ACCOUNT_ID");

const convertDotComProjectId = process.env.REACT_APP_CONVERT_DOT_COM_PROJECT_ID;
if (!convertDotComProjectId) throw configMissingExceptionMessage("REACT_APP_CONVERT_DOT_COM_PROJECT_ID");

const convertDotComDefaultVariationIdsStringified =
  process.env.REACT_APP_CONVERT_DOT_COM_DEFAULT_VARIATION_IDS?.toLowerCase();
if (!convertDotComDefaultVariationIdsStringified)
  throw configMissingExceptionMessage("REACT_APP_CONVERT_DOT_COM_DEFAULT_VARIATION_IDS");
const convertDotComDefaultVariationIds = JSON.parse(convertDotComDefaultVariationIdsStringified) as string[];
if (convertDotComDefaultVariationIds.constructor !== Array)
  throw configParseExceptionMessage("REACT_APP_CONVERT_DOT_COM_DEFAULT_VARIATION_IDS");

const escapePhoneNumber = process.env.REACT_APP_ESCAPE_PHONE_NUMBER;
if (!escapePhoneNumber) throw configMissingExceptionMessage("REACT_APP_ESCAPE_PHONE_NUMBER");

const escapeUrl = process.env.REACT_APP_ESCAPE_URL;
if (!escapeUrl) throw configMissingExceptionMessage("REACT_APP_ESCAPE_URL");

const aspireBaseUrl = process.env.REACT_APP_ASPIRE_API_URL;
if (!aspireBaseUrl) throw configMissingExceptionMessage("REACT_APP_ASPIRE_API_URL");

const fallbackCustomerDistanceToCenter = Number(process.env.REACT_APP_FALLBACK_CUSTOMER_DISTANCE_TO_CENTER);
if (isNaN(fallbackCustomerDistanceToCenter))
  throw configParseExceptionMessage("REACT_APP_FALLBACK_CUSTOMER_DISTANCE_TO_CENTER");

const anonymousExperimentsFlag = process.env.REACT_APP_ANONYMOUS_EXPERIMENTS;
if (!anonymousExperimentsFlag) throw configMissingExceptionMessage("REACT_APP_ANONYMOUS_EXPERIMENTS");

const reservationLifespanSeconds = Number(process.env.REACT_APP_RESERVATION_LIFESPAN_SECONDS);
if (isNaN(reservationLifespanSeconds)) throw configParseExceptionMessage("REACT_APP_RESERVATION_LIFESPAN_SECONDS");

const calendarAllowedPaddingMinutes = Number(process.env.REACT_APP_CALENDAR_ALLOWED_PADDING_MINUTES);
if (isNaN(calendarAllowedPaddingMinutes))
  throw configParseExceptionMessage("REACT_APP_CALENDAR_ALLOWED_PADDING_MINUTES");

const thankYouUrl = process.env.REACT_APP_THANK_YOU_URL;
if (!thankYouUrl) throw configMissingExceptionMessage("REACT_APP_THANK_YOU_URL");

const postCustomerQualifications = process.env.REACT_APP_POST_CUSTOMER_QUALIFICATIONS === "true";

const gtmEnabled = process.env.REACT_APP_GTM_ENABLED === "true";
const gtmContainerId = process.env.REACT_APP_GTM_CONTAINER_ID;
const gtmAuth = process.env.REACT_APP_GTM_AUTH;
const gtmPreview = process.env.REACT_APP_GTM_PREVIEW;
const gtmCookiesWin = process.env.REACT_APP_GTM_COOKIES_WIN;

const schedulingLoaderTimeout = Number(process.env.REACT_APP_TIMINGS_MS_SCHEDULING_LOADER_TIMEOUT);
if (isNaN(schedulingLoaderTimeout)) throw configParseExceptionMessage("REACT_APP_TIMINGS_MS_SCHEDULING_LOADER_TIMEOUT");

const schedulingLoaderHeartbeat = Number(process.env.REACT_APP_TIMINGS_MS_SCHEDULING_LOADER_HEARTBEAT);
if (isNaN(schedulingLoaderHeartbeat))
  throw configParseExceptionMessage("REACT_APP_TIMINGS_MS_SCHEDULING_LOADER_HEARTBEAT");

/** The environment configuration for the current  application instance.
 * @remarks GUID values are all cast to lower case.
 */
const EnvironmentConfiguration = {
  a1cUpperLimit,
  aspireBaseUrl,
  anonymousExperiments: anonymousExperimentsFlag === "true",
  escapePhoneNumber,
  escapeUrl,
  convertDotCom: {
    accountId: convertDotComAccountId,
    projectId: convertDotComProjectId,
    defaultVariationIds: convertDotComDefaultVariationIds
  },
  name: environmentName,
  optimizedPatientScheduler: {
    fallbackCustomerDistanceToCenter,
    notSupportedCenterIds: [] as string[]
  },
  postCustomerQualifications,
  reservationLifespanSeconds,
  timingsMs: {
    schedulingLoaderHeartbeat,
    schedulingLoaderTimeout
  },
  version,
  calendarAllowedPaddingMinutes,
  thankYouUrl,
  googleTagsManager: {
    enabled: gtmEnabled,
    containerId: gtmContainerId,
    auth: gtmAuth,
    preview: gtmPreview,
    cookiesWin: gtmCookiesWin
  }
};

export default EnvironmentConfiguration;
